module.exports = __webpack_public_path__ + "img/down_caret.40c26b54.svg";